import React from "react";

export default function SectionHeader({ eyebrow, title, intro, align = "left", testid }) {
  const isCenter = align === "center";
  return (
    <div
      className={`max-w-3xl ${isCenter ? "mx-auto text-center" : ""}`}
      data-testid={testid || "section-header"}
    >
      {eyebrow && (
        <p className="text-overline text-[#4B7055] mb-4">{eyebrow}</p>
      )}
      <h2 className="heading-section text-3xl sm:text-4xl lg:text-5xl text-[#0A1F35]">
        {title}
      </h2>
      {intro && (
        <p className="mt-5 text-base sm:text-lg text-[#4A5568] leading-relaxed">
          {intro}
        </p>
      )}
    </div>
  );
}
